import { propertyCategoryMapper } from "apps/propertySelection/propertyCategory/constants";
import { PropertyTypePage } from "apps/propertySelection/propertyType/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(PropertyTypePage(propertyCategoryMapper.Unique), "PropertyTypePage");
